module.exports = __webpack_public_path__ + "img/My Application.5c5d5de5.svg";